module.exports = __webpack_public_path__ + "img/yes_name.9cdc97e1.png";